module.exports = __webpack_public_path__ + "static/img/logo_meixin2_3x.17a213b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/personal/imgs/logo_meixin2_3x.png
// module id = 368
// module chunks = 68